import React from 'react';
import styles from './AboutMe.module.css';
import instaLogo from '../logos/insta.png';
import linkedInLogo from '../logos/linkedIn.png';
import githubLogo from '../logos/github.png';
import emailLogo from '../logos/email.png';
import phoneLogo from '../logos/phone.png';
import myPicture from '../pictures/me3.jpg';
import Skills from './Skills';

function AboutMe() {
  const englishCV = '/englishCV.pdf';
  return (
    <>
      <div className={styles.info}>
        <div className={styles.rightContent}>
          <Skills />
          <img src={myPicture} className={styles.pic} alt="Krisztian Gal" />
        </div>
        <div className={styles.bio}>
          <ul className={`${styles.text} ${styles.list}`}>
            <li>Frontend Developer wannabe</li>
            <li>Student of the <a href="https://www.oulu.fi/en" target="_blank" rel="noopener noreferrer">University of Oulu</a></li>
            <li>Studying Software Engineering</li>
            <li>Just deployed my first web app</li>
            <li>Look at what I'm reading <a href="https://www.goodreads.com/user/show/131959291-krisz" target="_blank" rel="noopener noreferrer">here</a></li>
            <li>born in Hungary, living in Finland</li>
            <li>Look at my first vlog series <a href="https://www.youtube.com/@krisztian_fi" target="_blank" rel="noopener noreferrer">on YouTube</a></li>
          </ul>
        </div>
        <div className={styles.cv}>
          <p className={styles.text}>Download my CV </p><div className={styles.button}><a href={englishCV} download> here</a></div>
        </div>
        </div>
      <div className={styles.contact}>
        <div className={styles.bgText}>Contact</div>
        <div className={styles.smolCont}>
          <div>
            <ul className={`${styles.text} ${styles.social}`}>
              <li><img src={instaLogo} className={styles.logos} alt="Instagram logo" /><a href="https://www.instagram.com/krisztian.fi/" target="_blank" rel="noopener noreferrer"> Instagram</a></li>
              <li><img src={linkedInLogo} className={styles.logos} alt="LinkedIn logo" /><a href="https://www.linkedin.com/in/krisztiang/" target="_blank" rel="noopener noreferrer"> LinkedIn</a></li>
              <li><img src={githubLogo} className={styles.logos} alt="Github logo" /><a href="https://github.com/krisztiangal" target="_blank" rel="noopener noreferrer"> Github</a></li>
            </ul>
          </div>
          <div>
            <ul className={`${styles.text} ${styles.official}`}>
              <li><a href="mailto:contact@krisztian.fi"> contact@krisztian.fi  </a><img src={emailLogo} className={styles.logos} alt="Email icon" /></li>
              <li><a href="tel:+358406403037"> +358406403037  </a><img src={phoneLogo} className={styles.logos} alt="Phone icon" /></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutMe;
